import styled from 'styled-components'
import { ContentHeader } from '../../../App'
import Item from '../Components/ThirdStepItem'
import Heading from '../Heading'
import { useContext, useEffect, useRef } from 'react'
import Textarea from '../../Form/Textarea'
import { OrderItemsContext, OrderDataContext, ErrorContext, MenuContext } from "../Context/WaiterContext"
import { Box, List, ListItem } from '@chakra-ui/react'

function Third ({ page }) {
    const myRef = useRef(null)
    const { orderItems } = useContext(OrderItemsContext)
    const { order, setOrder } = useContext(OrderDataContext)
    const { errors } = useContext(ErrorContext)
    const { menu } = useContext(MenuContext)

    useEffect(() => {
        if (errors?.time || errors?.location) {
            myRef.current.scrollIntoView()
        }
    }, [errors])

    const setComment = (value) => {
        setData('comment', value)
    }

    const setData = (key, value) => {
        setOrder({
            ...order,
            [key]: value,
        })
    }

    const drinks = [];
    const food = [];
    const drinkCategories = [2, 3, 29, 30, 32, 33, 39];

    for (const [itemId, data] of Object.entries(orderItems)) {
        const found = menu.find(element => element.id === Number(itemId))
        if (!found) {
            return;
        }

        if (drinkCategories.includes(found.group_id)) {
            drinks.push({
                id: found.id,
                quantity: data.quantity,
                children: data.children ? data.children : [],
            })
        } else {
            food.push({
                id: found.id,
                quantity: data.quantity,
                children: data.children ? data.children : [],
            })
        }
    }

    const renderOrderItemList = () => {
        return (<>
            <Title className="drinks-block">Drinks</Title>
            <Order>
                {drinks.length === 0 ? (<Box py={2}>No drinks</Box>) : drinks.map((drink, key) =>
                    <Item key={key} id={drink.id} quantity={drink.quantity} items={menu} children={drink.children} />
                )}
            </Order>
            <Title className="drinks-block">Food</Title>
            <Order>
                {food.length === 0 ? (<Box px={2}>No food</Box>) : food.map((food, key) =>
                    <Item key={key} id={food.id} quantity={food.quantity} items={menu} children={food.children}/>
                )}
            </Order>
            </>
        )
    }

    return (
        <Wrapper>
            <ContentHeader>
                <Heading page={page} />
                <Title className="drinks-block">Info</Title>
                <List align="left">
                    <ListItem><b>Location:</b> { order.location }</ListItem>
                    <ListItem><b>Table:</b> { order.table }</ListItem>
                </List>
                {Object.keys(orderItems).length > 0 ?
                    renderOrderItemList() : <Order>Table booking only</Order>
                }
                <Form ref={myRef}>
                    <Textarea placeholder={'Comment (optional)'} value={order.comment} setValue={setComment} />
                </Form>
            </ContentHeader>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    flex: 1;
    flex-direction: column;
`

const Order = styled.div`
    background: #E8E8E8;
    border-radius: 10px;
    padding: 15px;
    padding-top: 0;
    padding-bottom: 0;
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.19);
    margin-bottom: 20px;
    border-color: #AE996F;
    border-width: 1px;
`

const Title = styled.div`
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
`

const Form = styled.div`
    margin-top: 20px;

    & > * {
        margin-bottom: 20px;
    }
`

export default Third;
